import { render, staticRenderFns } from "./InboxGroup.vue?vue&type=template&id=119610f6"
import script from "./InboxGroup.vue?vue&type=script&lang=js"
export * from "./InboxGroup.vue?vue&type=script&lang=js"
import style0 from "./InboxGroup.vue?vue&type=style&index=0&id=119610f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports